import { GridColDef } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { AdSpacePhotoInterface } from '../../../interfaces/interfaces';

export const getAdSpacePhotoColumns = (
  setPhotoToDelete: (photo: AdSpacePhotoInterface) => void,
  setDeleteDialogOpen: (open: boolean) => void,
  setPhotoToUpdate: (photo: AdSpacePhotoInterface) => void,
  setUpdateDialogOpen: (open: boolean) => void
): GridColDef[] => [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'adSpaceId', headerName: 'Ad Space ID', width: 120 },
  { field: 'photoUrl', headerName: 'Photo URL', width: 250 },
  { field: 'active', headerName: 'Active', width: 90, type: 'boolean' },
  { field: 'created_at', headerName: 'Created', width: 150 },
  { field: 'updated_at', headerName: 'Updated', width: 150 },
  {
    field: 'delete',
    headerName: 'Delete',
    width: 100,
    renderCell: (params) => (
      <Button
        color="error"
        variant="outlined"
        size="small"
        onClick={() => {
          setPhotoToDelete(params.row);
          setDeleteDialogOpen(true);
        }}
      >
        Delete
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
  {
    field: 'update',
    headerName: 'Update',
    width: 100,
    renderCell: (params) => (
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={() => {
          setPhotoToUpdate(params.row);
          setUpdateDialogOpen(true);
        }}
      >
        Update
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
];